import HeroSection from './components/HeroSection';
import ComparisonSection from './components/ComparisonSection';
import TechnologySection from './components/TechnologySection';
import UseCaseSection from './components/UseCaseSection';
import EvidenceSection from './components/EvidenceSection';
import CTASection from './components/CTASection';
import CoCreationSection from './components/CoCreationSection';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-black">
      <HeroSection />
      <ComparisonSection />
      <TechnologySection />
      <UseCaseSection />
      <EvidenceSection />
      <CTASection />
      <CoCreationSection />
      <Footer />
    </div>
  );
}
